var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalcFigureAreaSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 250 250",
    xmlns: "http://www.w3.org/2000/svg",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    id: "Artboard1",
    x: 0,
    y: 0,
    width: 250,
    height: 250,
    style: {
      fill: "none"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "Artboard11"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.804138,0,0,0.804138,43.1387,45.4429)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.495,
    y: 27.624,
    width: 184.923,
    height: 184.923,
    style: {
      fill: "none",
      stroke: "black",
      strokeWidth: "3.73px"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(6.01217e-17,0.981862,-0.245851,1.5054e-17,76.5799,52.9637)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.945,106.4L25.945,121.324L15.98,101.425L25.945,81.527L25.945,96.451L157.466,96.451L157.466,81.527L167.431,101.425L157.466,121.324L157.466,106.4L25.945,106.4Z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.981862,-1.2326e-32,0,0.245851,51.1667,28.9524)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.945,106.4L25.945,121.324L15.98,101.425L25.945,81.527L25.945,96.451L157.466,96.451L157.466,81.527L167.431,101.425L157.466,121.324L157.466,106.4L25.945,106.4Z"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,-43.6511,112.895)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "l")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,60.3328,9.56752)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "l")), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.967528,0,0,0.967528,60.0503,111.898)"
  }, /*#__PURE__*/React.createElement("text", {
    x: "78.3px",
    y: "36.332px",
    style: {
      fontFamily: "'AndaleMono', 'Andale Mono', monospace",
      fontSize: "18.119px"
    }
  }, "A"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalcFigureAreaSquare);
export default __webpack_public_path__ + "static/media/calc-figure-area-square.55402daeeed1d3697eb6e463175210af.svg";
export { ForwardRef as ReactComponent };